import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import SplitButton from './ClassDashboard/SplitButton';
import ClassTable from './ClassDashboard/ClassTable';
import useCustomData from '../../../context/useCustomData'
import AutocompleteFinder from './ClassDashboard/AutocompleteFinder';
import PageInfo from './ClassDashboard/PageInfo';

const ClassDashboard = () => {
  const { classGroupWeek, isLoading, isError, refresh } = useCustomData()
  const [dayIndex, setDayIndex] = useState(0)
  const [classDay, setClassDay] = useState(null)

  //if (isLoading) return <h1>Loading data...</h1>
  //if (isError) return <h1>Error loading data...</h1>

  const handleSelectDay = (optionIndex) => {
    setDayIndex(optionIndex)
  };

  useEffect(() => {
    if (classGroupWeek) {
      setClassDay(classGroupWeek[dayIndex])
    }
  }, [dayIndex, classGroupWeek])

  return (
    <Grid container justifyContent="center" alignItems="center" height="100vh">
      <Grid item xs={12} md={10} lg={8}>
        <Box
          sx={{
            alignItems: 'center',
            mt: 3,
          }}
        >
          <PageInfo />
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 2,
            mt: 2,
            width: '100%',
          }}
        >
          <SplitButton options={classGroupWeek.map(cld => cld.getDayTitle())} setOption={handleSelectDay} />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mt: 2,
              width: '100%',
              maxWidth: 400,
            }}
          >
            <AutocompleteFinder
              optionList={classDay ? classDay.getMainInformation() : ["..."]}
              arrayData={classDay ? classDay.getAllClassData() : null}
              style={{ width: '80%' }}
            />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={10} lg={8}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: 2,
            mt: 2,
            width: '100%',
          }}
        >
          <ClassTable arrayData={classDay ? classDay.getAllClassData() : null} style={{ width: '100%' }} />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ClassDashboard;
